import React from 'react';
import styles from './DrivingBtn.module.scss';
import RoundedButton from '../../../../../../../components/RoundedButton/RoundedButton';
import cn from 'classnames';
import useArrival from '../../../../../shared/api/mutation/useArrival';
import useDeparture from '../../../../../shared/api/mutation/useDeparture';
import { Icon } from 'antd';

const DrivingBtn = ({ record }) => {
  const { mutateAsync: onArrival, isLoading: isLoadingArrival } = useArrival();
  const { mutateAsync: onDeparture, isLoading: isLoadingDeparture } =
    useDeparture();

  const handleArrival = () => {
    if (!!record?.entryDate) return;

    onArrival(record?.id);
  };

  const handleDeparture = () => {
    if (!!record?.leftDate) return;

    onDeparture(record?.id);
  };

  return (
    <div className={styles.root}>
      <RoundedButton
        text="Заехал"
        iconRight={isLoadingArrival && <Icon type="loading" />}
        className={cn(styles.btnc, {
          [styles.isActive]: !!record?.entryDate && !record?.leftDate,
        })}
        disabled={!!record?.leftDate}
        onClick={handleArrival}
      />
      <RoundedButton
        text="Выехал"
        iconRight={isLoadingDeparture && <Icon type="loading" />}
        className={cn(styles.btnc, {
          [styles.isActive]: !!record?.leftDate,
        })}
        disabled={!record?.entryDate}
        onClick={handleDeparture}
      />
    </div>
  );
};
export default DrivingBtn;
